import { Component, OnInit } from '@angular/core';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { ActorDashBoardProfileSummaryInfoRequest } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { Subscription } from 'rxjs';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { Router, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NgbScheduleAssistantModal } from '../../testnurse/testnurse2/scheduleassistant/scheduleassistant.modal';
import { NgbAddNewPatient } from '../provider/dashboard/modal/addnewpatient.modal';
import { NgbAddBill } from '../opbilling/modal/addbill.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    GetActorIdentitiesController(): any {
        throw new Error("Method not implemented.");
    }
  HasAccess(featureName: string): boolean {

    /*return*/ false;
    //////  alert(featureName);
    var f = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.filter(function (v, i, d) {
      return v.FeatureName == featureName && AppData.Instance().SelectedRoleName == v.RoleName;
    });
    //if (featureName == 'Patients List') {

    //    alert(f.length);
    //}
    //alert(f.length);
    //return f != null && f.length > 0;
    return false;
  }
    HasAccess2(featureName: string): boolean {

    /*return*/ false;
        //////  alert(featureName);
        var f = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.filter(function (v, i, d) {
            return v.FeatureName == featureName && AppData.Instance().SelectedRoleName == v.RoleName;
        });
        //if (featureName == 'Patients List') {

        //    alert(f.length);
        //}
        //alert(f.length);
        return f != null && f.length > 0;
    }

    public ActorCode: number = 0;
  public TestVersion: Boolean = false;
    public isRequesting: boolean = false;
    CurrentIsSessionExistsRequest: IsSessionExistsRequest;
    public ApiResData: ApiResponseModel;

    CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
    CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;


    sub: Subscription;
    ngOnInit() {

        this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
        this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();

        this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
        this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDashBoardProfileSummaryController();


    }

    constructor(private router: Router,
        private loaderService: SpinnerService,
        private hcpservice: HCPService,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private loginservice: LoginService) { }



    GetDashBoardProfileSummaryController() {
        //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
        this.StartRefreshing();
        this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //  console.log('GetActorProfileController');
                    this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    openScheduleAssistant() {
        //alert("...");
        const modalRef = this.modalService.open(NgbScheduleAssistantModal,
            {
                centered: true,
                size: "lg"
            })
        modalRef.componentInstance.ActorCode = this.ActorCode;
        modalRef.result.then(x => { this.GetActorIdentitiesController() })

    }
    OpenModal() {
        const modalRef = this.modalService.open(NgbAddNewPatient,
            {
                centered: true,
                size: "lg",
                backdrop: 'static',
                keyboard: false
            })
    }
    //OpenBill() {
    //    const modalRef = this.modalService.open(NgbAddBill,
    //        {
    //            centered: true,
    //            size: "lg",
    //            backdrop: 'static',
    //            keyboard: false
    //        })
    //}
  OpenBill() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((val: string) => {

      this.router.navigate(['healins/receipt', { FormattedCodedata: val }]);

      // modalRef.componentInstance.FormattedCode = val;
      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetTreatmentCyclesController() })
    });
  }

    ///////////
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }








}


